<!--底部-->
<template>
  <div>
    <div class="foot">
      <div class="container-wc link">
        <div class="select">
          <span class="label">下属企业&nbsp;</span>
          <Select v-model="SelectIndex" style="width:400px" @on-select="changeSelect">
            <Option :value="index" v-for="(item, index) of dataList" :key="index">{{ item.title }}</Option>
          </Select>

        </div>

        <div class="text">
          <div class="a"><img class="icon" src="../assets/image/icon01.png" /><span class="at">关注产城</span>
            <div class="wxImg wxImgGG"><img src="../assets/image/ewm.jpg" alt=""><span>扫描二维码</span>
              <p>关注“徐州产城集团”</p>
            </div>
          </div>
          <div class="b">|</div>
          <div class="a" @click="toPage(tree)"><img class="icon" style="border-radius: 10px;"
              src="../assets/image/icon02.png" /><span class="at">联系我们</span></div>
          <div class="b">|</div>
          <!-- <div class="a" @click="openOA"><img class="icon" src="../assets/image/icon03.png" /><span class="at">OA办公系统</span></div> -->
          <!-- <div class="b">|</div> -->
          <div class="a"><img class="icon" src="../assets/image/icon04.png" /><span class="at">信访举报</span>
            <div class="wxImg xifang">
              <p>监督举报电话：0516-80809691 0516-83396120</p>
              <p>举报电子邮箱:：xzccjtjw@163.com</p>
              <p>来信来访地址：徐州市云龙区秦郡路1号金融集聚区F座2012室</p>
              <p>邮政编码：221018</p>
              <!-- <p>邮政编码：221000</p> -->
            </div>
          </div>
          <div class="b">|</div>
          <div class="a">
            <img class="icon" src="../assets/image/icon05.png" />
            <span class="at">友情链接</span>
            <div class="wxImg linkList">
              <a :href="item.value" target="_blank" :alt="item.name" :title="item.name" v-for="(item, index) of labelList"
                :key="index">{{ item.name }}</a>
            </div>
          </div>

        </div>
      </div>
      <div class="container-wc pc">Copyright © 2019 All Rights Reserved 版权所有：徐州市产城发展集团有限公司 <a
          href="https://beian.miit.gov.cn" target="_blank">苏ICP备2023011950号-1</a>
        <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32030302001089"><img
            style="margin:-4px 5px 0 10px" src="../assets/gaba.png" />苏公网安备32030302001089号</a>
      </div>
    </div>

  </div>
</template>

<script>
import { GetContentList, GetlabelList } from "@/api";

export default {

  inject: ["skipPage"],
  data() {
    return {
      SelectIndex: localStorage.getItem("SelectIndex")
        ? Number(localStorage.getItem("SelectIndex"))
        : 0,
      dataList: [],
      labelList: [],


    };
  },
  mounted() {
    GetContentList({
      scode: 297, page: 1, limit: 1000
    }).then((res) => {
      this.dataList = res.data;
    });
    GetlabelList().then(res => {
      this.labelList = res
    })

  },
  computed: {
    //所有菜单
    tree() {
      return this.$store.state.user.tree;
    },
  },

  methods: {

    changeSelect(e) {
      localStorage.setItem("SelectIndex", e.value)
      this.skipPage(this.dataList[e.value], 0)
    },

    openOA() {
      window.open('http://140.246.7.120:90')
    },

    //跳转详情
    toPage(tree) {
      tree.forEach((item) => {
        if (item.subs) {
          for (let i = 0; i < item.subs.length; i++) {
            if (item.subs[i].name == "联系我们") {
              this.skipPage(item.subs[i])
              break;
            }
          }
        }
      });

    },
  },
};
</script>

<style scoped lang="less">
.foot {
  background-color: #262626;

  .link {
    display: flex;
    align-items: center;
    padding: 11px 0;
    border-bottom: 1px dashed #000;

    .select {
      flex: 1;

      .label {
        font-size: 16px;
        padding-right: 1px;
        color: #939393;
      }
    }

    .text {
      display: flex;
      align-items: center;
      font-size: 16px;


      .a {
        transition: all 0.2;
        cursor: pointer;
        position: relative;
        line-height: 32px;
        color: #cbcbcb;
        vertical-align: middle;

        .at {
          opacity: .7;
          transition: all .3s;
        }

        .icon {
          vertical-align: middle;
          margin-top: -3px;
          opacity: .7;
          transition: all .3s;
        }

        &:hover {
          .wxImg {
            display: block;
          }

          .at {
            opacity: 1;
          }

          .icon {
            opacity: 1;
          }
        }

        .wxImg {
          display: none;
          position: absolute;
          bottom: 35px;
          left: -10px;
          padding: 0;
          border-radius: 10px;
        }

        .wxImgGG {
          // display: block;
          background-color: #fff;
          text-align: center;
          font-size: 12px;
          color: #333;
          line-height: 16px;
          padding-bottom: 10px;
        }

        .xifang {
          width: 518px;
          height: 204px;
          font-family: Arial, Helvetica, sans-serif;
          background: url('../assets/image/jb.png') no-repeat center center;
          left: -330px;
          bottom: 22px;
          padding: 30px 25px 35px 30px;
          line-height: 36px;
          font-size: 16px;
          color: #555555;
        }

        .linkList {
          border-radius: 4px;
          background-color: rgb(255, 255, 255);
          box-shadow: 0px 1px 8px 0px rgba(47, 47, 47, 0.26);
          width: 195px;
          bottom: 30px;
          left: -45px;
          padding: 10px 0;
          max-height: 175px;
          overflow-y: scroll;

          a {
            padding: 0 10px;
            display: block;
            line-height: 38px;
            text-align: center;
            color: #555555;
            height: 38px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            transition: all .3s;

            &:hover {
              color: #b50104;
            }
          }
        }
      }

      a {
        transition: all 0.2;
        cursor: pointer;
        position: relative;
        color: #515a6e;

        &:hover {
          color: #b50104;

          .wxImg {
            display: block;
          }
        }

        .wxImg {
          display: none;
          position: absolute;
          bottom: 35px;
          left: 0;
          padding: 0;
        }

      }

      .b {
        color: #939393;
        font-size: 12px;
        padding: 0 13px;
      }
    }
  }

  .pc {
    color: #939393;
    line-height: 46px;
    font-size: 16px;

    a {
      color: #939393;
      transition: all .3s;

      &:hover {
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue